var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Dialog } from '@material-ui/core';
import styled from 'styled-components';
export var LoaderDialog = styled(function (props) { return (React.createElement(Dialog, __assign({}, props, { classes: { paper: 'LoaderDialog-paper' } }))); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .LoaderDialog-paper {\n    background-color: rgba(0, 0, 0, 0.7);\n    padding: 34px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"], ["\n  .LoaderDialog-paper {\n    background-color: rgba(0, 0, 0, 0.7);\n    padding: 34px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"])));
var templateObject_1;
